<div class="badge badge-{{ size }} badge-{{ type }}">
  <span *ngIf="text">
    {{ text }}
  </span>
</div>
